import { Actions, createEffect, ofType } from '@ngrx/effects';
import { inject, Injectable } from '@angular/core';
import { catchError, map, take } from 'rxjs/operators';
import { mergeMap, Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';
import { FooterActions } from '../actions';
import { ConfigurationFacade } from '../facades/configuration.facade';
import { IFooter } from '../models/footer.models';

@Injectable({
  providedIn: 'root',
})
export class FooterEffects {
  private readonly actions$: Actions = inject(Actions);
  private readonly configFacade: ConfigurationFacade = inject(ConfigurationFacade);

  readonly loadSocialMediaFooter$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(FooterActions.loadSocialMediaFooter),
      mergeMap(() => this.configFacade.getSocialMediaFooter().pipe(
        map((socialMediaFooter: IFooter) => {
          return FooterActions.loadSocialMediaFooterSuccess({socialMediaFooter: socialMediaFooter});
        }),
        catchError((error: string) => {
          return of(FooterActions.loadSocialMediaFooterFail({resError: error}));
        })
      )),
    ));

  readonly loadFooterNavigation$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(FooterActions.loadFooterNavigation),
      mergeMap(() => this.configFacade.getFooterNavigation().pipe(
        take(1),
        map((footerNavigation: IFooter) => {
          return FooterActions.loadFooterNavigationSuccess({footerNavigation: footerNavigation});
        }),
        catchError((error: string) => {
          return of(FooterActions.loadFooterNavigationFail({resError: error}));
        })
      )),
    ));
}
